import { load } from 'recaptcha-v3'
import BAMBORA from './bambora';

jQuery(($) => {


    $('[data-name="policy_number"]').append($('.policy-info'));
    $('.policy-info').removeClass('hidden');

    $('.policy-info').on('click', function(e) {
        e.preventDefault();
        $('#paymentInfoWindow').modal('show');
    });

    function checkPostalCode(postal_code) {
        var char_code = postal_code.split('');
        if(char_code[3] !== ' ') {
            return "Postal Codes must be in the format of 'ANA NAN' with a space in the middle.";
        }
        if(postal_code.length > 7 || postal_code.length < 7) {
            return "Incorrect format";
        }
    }

    function authStepCheck() {

        $('.non-valid').remove();
        $('.response-messages').empty();
        $('.step-1 .error').removeClass('error');

        if ($('#user_postal').val() =="" && $('#user_postal').parents('.hidden-payment-item').length == 0){
            $('#user_postal').addClass('error');
            $('[data-name=user_postal]').append('<div class="non-valid">Required</div>');
        }

        if($('#user_postal').parents('.hidden-payment-item').length == 0) {

            var check_postal = checkPostalCode($('#user_postal').val());

            if(check_postal) {
                $('#user_postal').addClass('error');
                $('[data-name=user_postal]').append('<div class="non-valid">'+check_postal+'</div>');
            }
            
        }

        if ($('#user_city').val() =="" && $('#user_city').parents('.hidden-payment-item').length == 0){
            $('#user_city').addClass('error');
            $('[data-name=user_city]').append('<div class="non-valid">Required</div>')
        }

        if ($('#policy_holders_name').val() ==""){
            $('#policy_holders_name').addClass('error');
            $('[data-name=policy_holders_name]').append('<div class="non-valid">Required</div>')
        }

        if ($('#policy_holders_name').val() !="" && !$('#policy_holders_name').val().match(/^[A-Za-z0-9 ]+$/)){
            $('#policy_holders_name').addClass('error');
            $('[data-name=policy_holders_name]').append('<div class="non-valid">Policyholder\'s name should not contain special characters.</div>')
        }

        var policy_number = $('#policy_number').val();
        if (policy_number =="" || policy_number.length != 11 || !policy_number.match(/^[a-zA-Z]{1}[0-9]{10}/s) || !policy_number.match(/^[\w&.-]+$/)){
            
            $('#policy_number').addClass('error');

            if( policy_number !="" && policy_number.length != 11){
                $('[data-name=policy_number]').append('<div class="non-valid">Policy numbers are 11 digits.</div>');
            }else if(policy_number !="" && !policy_number.match(/^[a-zA-Z]{1}[0-9]{10}/s)){ 
                $('[data-name=policy_number]').append('<div class="non-valid">Policy number begins with a letter followed by a series of numbers.</div>');
            }else if(policy_number !="" && !policy_number.match(/^[\w&.-]+$/)){ 
                $('[data-name=policy_number]').append('<div class="non-valid">Policy number should not contain special characters.</div>');
            }else{
                $('[data-name=policy_number]').append('<div class="non-valid">Required</div>');
            }

        }

        if ($('#user_phone').val() ==""){
            $('#user_phone').addClass('error');
            $('[data-name=user_phone]').append('<div class="non-valid">Required</div>');
        }

        if ($('#user_phone').val() !=""){
            var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if(!phoneno.test($('#user_phone').val())){
                $('[data-name=user_phone]').append('<div class="non-valid">Please enter a valid telephone number.</div>');
            }
        }

    }

    if($('.payment-multi-form').length > 0) {

        load('6LeKGeoqAAAAACOSyXQSC7Da1199Z6mXq69Yviwd').then((recaptcha) => {

                recaptcha.execute('load_cc_payment_form').then((token) => {

                    var items = $('.hidden-payment-item');
                    var item = items[Math.floor(Math.random()*items.length)];
                    $(item).removeClass('hidden hidden-payment-item');
                    $('.loading-spinner').addClass('hidden');
                    $('.step-1').addClass('show');
                
                    $('#auth-button').on('click', function(e) {
                        e.preventDefault();

                        authStepCheck();

                        if($('.step-1 .error').length > 0) {
                            console.log("Error in step #1");
                            return;
                        }

                        var policy_number = $('#policy_number').val();
                        var user_postal = $('#user_postal').val();
                        var user_city = $('#user_city').val();
                        var amount = $('#payment_amount').val();

                        if(policy_number && (user_postal || user_city)) {
                
                            var data = {"policy_number":policy_number};

                            data['payment_amount'] = amount;
                
                            if(user_postal) {
                                data['user_postal'] = user_postal;
                            } else if(user_city) {
                                data['user_city'] = user_city;  
                            }

                                $('.loading-spinner').removeClass('hidden');
                                $('.step-1').removeClass('show');
                
                            recaptcha.execute('policy_auth_request').then((token) => {

                                data['token'] = token;

                                jQuery.ajax({
                                    type: "post",
                                    dataType: "json",
                                    url: "/wp-json/payment_auth/v1/auth",
                                    data: data,
                                    success: function(msg){
                                        try {
                                            var msg = JSON.parse(msg);
                                        } catch(e) {
                                            //allow to continue to see if this returned an object instead of a json...
                                        }
                                        if(msg.data) {
                                            msg = msg.data;
                                        }
                                        if(msg.return === 1) {
                                            setTimeout(function() {
                                                $('.loading-spinner').addClass('hidden');
                                                $('.step-2').data('policy_holders_name', $('#policy_holders_name').val());
                                                $('.step-2').data('policy_number', $('#policy_number').val());
                                                $('.step-2').data('user_phone', $('#user_phone').val());
                                                $('.step-2').addClass('show');
                                                BAMBORA.init();
                                            }, 1000);
                                        } else {
                                            var code = msg.return;
                                            $('.loading-spinner').addClass('hidden');
                                            if(code === 0) {
                                                $('.step-1').addClass('show');
                                            } else {
                                                $('.response-messages').addClass('lockout');
                                            }
                                            $('.response-messages').prepend(msg.message);
                                        }
                                    }
                                });

                            });
                
                        }
                
                    });
                

                
                });

        });

    }
    
});
